/**
 * AdminDashboard object represents Dashboard API endpoints and their methods.
 */
const AdminDashboard = {
  /**
   * Endpoint for retrieving dashboard information.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving dashboard information.
   * @property {string} method - The HTTP method for retrieving dashboard information (GET).
   */
  getAdminDashboard: {
    url: "/admin/dashboard",
    method: "GET",
  },

  /**
   * Endpoint for retrieving weekly active users analytics.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving weekly active users data.
   * @property {string} method - The HTTP method for retrieving analytics (GET).
   */
  getWeeklyActiveUsers: {
    url: "/admin/analytics/weekly-active-users",
    method: "GET",
  },

  /**
   * Endpoint for retrieving monthly active users analytics.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving monthly active users data.
   * @property {string} method - The HTTP method for retrieving analytics (GET).
   */
  getMonthlyActiveUsers: {
    url: "/admin/analytics/monthly-active-users",
    method: "GET",
  },

  /**
   * Endpoint for retrieving daily active users analytics.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving daily active users data.
   * @property {string} method - The HTTP method for retrieving analytics (GET).
   */
  getDailyActiveUsers: {
    url: "/admin/analytics/daily-active-users",
    method: "GET",
  },

  /**
   * Endpoint for retrieving daily signup users analytics.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving daily signup users data.
   * @property {string} method - The HTTP method for retrieving analytics (GET).
   */
  getDailySignups: {
    url: "/admin/analytics/daily-signups",
    method: "GET",
  },

  /**
   * Endpoint for retrieving subscription analytics.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving subscription analytics data.
   * @property {string} method - The HTTP method for retrieving analytics (GET).
   */
  getSubscriptionAnalytics: {
    url: "/admin/analytics/subscriptions",
    method: "GET",
  },

  /**
   * Endpoint for retrieving user retention analytics.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving user retention data.
   * @property {string} method - The HTTP method for retrieving analytics (GET).
   */
  getUserRetentionAnalytics: {
    url: "/admin/analytics/user-retention",
    method: "GET",
  },

  /**
   * Endpoint for retrieving platform distribution analytics.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving platform distribution data.
   * @property {string} method - The HTTP method for retrieving analytics (GET).
   */
  getPlatformDistribution: {
    url: "/admin/analytics/platform-distribution",
    method: "GET",
  },

  // Legacy endpoints (keeping for backwards compatibility)
  /**
   * Endpoint for retrieving pie chart information.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving pie chart information.
   * @property {string} method - The HTTP method for retrieving pie chart information (GET).
   */
  getAdminPieChartData: {
    url: "/admin/dashboard/pie-chart",
    method: "GET",
  },

  /**
   * Endpoint for retrieving line graph information.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving line graph information.
   * @property {string} method - The HTTP method for retrieving line graph information (GET).
   */
  getAdminLineGraphData: {
    url: "/admin/dashboard/line/graph",
    method: "GET",
  },

  getFoodScanAnalytics: {
    url: "/admin/analytics/food-scan-analytics",
    method: "GET",
  },
  getCountryDistribution: {
    url: "/admin/analytics/country-distribution",
    method: "GET",
  },

};

export default AdminDashboard;
